var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("h5", { staticStyle: { color: "#C0C4CC" } }, [_vm._v("下单商品")]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.selectOrderTableData,
                "row-key": "sid",
                "show-header": false,
                "row-style": { color: "red" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  align: "center",
                  width: "50",
                  type: "index",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cgoodsSku",
                  align: "center",
                  label: "SKU",
                  width: "90",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "图片", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cmasterUrl != null
                          ? _c("el-image", {
                              staticClass: "w30 h30",
                              attrs: {
                                "preview-src-list": [scope.row.cmasterUrl],
                                src: scope.row.cmasterUrl,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品编码",
                  align: "center",
                  width: "130",
                  prop: "cgoodsBarcode",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  align: "center",
                  prop: "cgoodsName",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "单位", align: "center", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "单价", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "￥ " +
                              _vm._s((scope.row.dgoodsPrice / 100).toFixed(2))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "数量",
                  prop: "ngoodsNum",
                  align: "center",
                  width: "130",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("pickingChangeChoose", {
            ref: "pickingChangeChoose",
            attrs: { "store-id": _vm.storeId },
            on: { OrderGoodsAdd: _vm.handleChooseGiveGoods },
          }),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("h5", { staticStyle: { color: "#C0C4CC" } }, [_vm._v("替换货品")]),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = true
                },
              },
            },
            [_vm._v("选取")]
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.replaceTableData,
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                },
                "row-style": { background: "#f5f7fa" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  align: "center",
                  width: "50",
                  type: "index",
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "SKU", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { maxlength: "5", placeholder: "SKU" },
                          on: {
                            input: function ($event) {
                              return _vm.checkSKU(scope.$index, scope.row)
                            },
                          },
                          model: {
                            value: scope.row.cremark,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "cremark", $$v)
                            },
                            expression: "scope.row.cremark",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "图片", align: "center", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cmasterUrl != null
                          ? _c("el-image", {
                              staticClass: "w50 h50",
                              attrs: {
                                "preview-src-list": [scope.row.cmasterUrl],
                                src: scope.row.cmasterUrl,
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "货品编码",
                  align: "center",
                  width: "130",
                  prop: "csku",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "货品名称", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              disabled: !scope.row.cname,
                              content: scope.row.cname,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { color: "red" },
                                attrs: {
                                  filterable: "",
                                  placeholder: "请选择",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.checkGoodsName(
                                      scope.$index,
                                      scope.row
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.cname,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "cname", $$v)
                                  },
                                  expression: "scope.row.cname",
                                },
                              },
                              _vm._l(_vm.options, function (item) {
                                return _c("el-option", {
                                  key: item.sid,
                                  attrs: { label: item.label, value: item.sid },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "单位",
                  align: "center",
                  width: "50",
                  prop: "cunit",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "单价", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.nprice
                          ? _c("div", [
                              _vm._v("￥ " + _vm._s(scope.row.nprice)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "库位",
                  align: "center",
                  width: "70",
                  prop: "cwarehouse",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "数量", align: "center", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cremark || scope.row.cname
                          ? _c("el-input-number", {
                              attrs: {
                                "controls-position": "right",
                                min: 1,
                                max: 999,
                              },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "可用库存", align: "center", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "hHP wHP flex marginLeft10",
                            staticStyle: { "white-space": "break-spaces" },
                          },
                          [_vm._v(" " + _vm._s(scope.row.navailable) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center", width: "55" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "red",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.onDel(scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex alignItemsCenter marginTop10",
          staticStyle: { "justify-content": "space-between", flex: "1" },
        },
        [
          _c("div"),
          _c(
            "div",
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "添加商品",
            visible: _vm.dialogVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("inventOrderGoodsAdd", {
                attrs: { "select-store": { rstore: _vm.storeId } },
                on: {
                  handleClose: _vm.handleClose,
                  handleChoose: _vm.handleChooseGiveGoods,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }